import React from 'react'
import classes from './Tag.module.scss'
import clsx from 'clsx'

export type TagProps = {
  children: string
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning'
  variant?: 'solid' | 'soft' | 'outlined'
}

const Tag = ({ color = 'primary', variant = 'solid', children }: TagProps) => {
  const className = clsx(classes.root, {
    [classes.primary]: color === 'primary',
    [classes.success]: color === 'success',
    [classes.warning]: color === 'warning',
    [classes.neutral]: color === 'neutral',
    [classes.danger]: color === 'danger',
    [classes.solid]: variant === 'solid',
    [classes.soft]: variant === 'soft',
    [classes.outlined]: variant === 'outlined',
  })

  return <div className={className}>{children}</div>
}

export default Tag
